import { createNativeStackNavigator } from '@react-navigation/native-stack';
import SettingsScreen from 'src/presentation/screens/SettingsScreen';
import FeedbackScreen from 'src/presentation/screens/FeedbackScreen';
import ContactScreen from 'src/presentation/screens/ContactScreen';
import EditProfileScreen from 'src/presentation/screens/EditProfileScreen';
import UpdatePasswordScreen from 'src/presentation/screens/UpdatePasswordScreen';
import RegistrationFormScreen from 'src/presentation/screens/RegistrationFormScreen';
import LoginFormScreen from 'src/presentation/screens/LoginFormScreen';
import ForgotPasswordScreen from 'src/presentation/screens/ForgotPasswordScreen';
import Constants from 'src/core/utils/Constants';
import type { SettingsStackParamList } from 'src/presentation/navigation/types/NavigationTypes';

const SettingsStack = createNativeStackNavigator<SettingsStackParamList>();

function SettingsStackNavigator() {
	return (
		<SettingsStack.Navigator
			initialRouteName={Constants.screenSettingsRoot}
			screenOptions={{ headerShown: false, freezeOnBlur: true }}
		>
			<SettingsStack.Screen component={SettingsScreen} name={Constants.screenSettingsRoot} />
			<SettingsStack.Screen component={FeedbackScreen} name={Constants.screenFeedbackPage} />
			<SettingsStack.Screen component={ContactScreen} name={Constants.screenContactPage} />
			<SettingsStack.Screen component={EditProfileScreen} name={Constants.screenProfilePage} />
			<SettingsStack.Screen component={UpdatePasswordScreen} name={Constants.screenUpdatePassword} />
			<SettingsStack.Screen component={RegistrationFormScreen} name={Constants.screenProfileRegistrationPage} />
			<SettingsStack.Screen component={LoginFormScreen} name={Constants.screenProfileLoginPage} />
			<SettingsStack.Screen component={ForgotPasswordScreen} name={Constants.screenLostPasswordPage} />
		</SettingsStack.Navigator>
	);
}

export default SettingsStackNavigator;
